// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"LotteryDetailKv_goodsmilekuji_componentStyle__s6ILE"};